//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { prokeyAuditQCCreate, removeListener, onTenants, requestTenants, requestAuditModes, onAuditModes} from 'api/prokey/prokey.websocket';

// === STYLES ===
import { useTheme } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import { Autocomplete } from '@mui/material/index';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Select,
  MenuItem,
  FormControl,
  OutlinedInput,
  InputLabel,
} from '@mui/material';

//-----------------------------------------------------------------
function Alert(props) {
  //-----------------------------------------------------------------
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

//#endregion

function AddAuditQCDialog(props) {

  //#region [VALUES]

  const theme = useTheme(); 

  const [ tenant         , setTenant ]          = useState('');
  const [ auditMode      , setAuditMode ]       = useState('');
  const [ auditType      , setAuditType ]       = useState('');
  const [ fieldName      , setFieldName ]       = useState('');
  const [ fieldValue     , setFieldValue ]      = useState('');
  const [ auditReturnCode, setAuditReturnCode ] = useState('');
  const [ auditFrequency , setAuditFrequency  ] = useState( 1 );
  const [ auditCount     , setAuditCount ]      = useState( 0 );

  const [ tenants        , setTenants ]         = useState([]);
  const [ auditModes     , setAuditModes ]      = useState([]);

  const auditTypeOptions       = [ 'Sync', 'Async' ];
  const auditReturnCodeOptions = [ 'Normal', 'Forward' ];

  const [ showAlert, setShowAlert ] = useState(false);
  const [ alertText, setAlertText ] = useState('');
 
  //#endregion

  //#region [EFFECT]

  //#endregion
  
  //#region [STYLES]
  
  // === STYLE ===
  const _styles = {
    container: {
    },
    form: {
    },
  }

  const
    CONTAINER = {
      sx : _styles.container,
    },
    FORM = {
      sx        : _styles.form,
      fullWidth : true,
      margin    :'dense',
    },
    DIALOG = {
      sx             : _styles.container,
      open           : props.showDialog,
      onClose        : handleClose,
      ariaLabelledby : 'form-dialog-title',
    },    
    TENANT = {
      id           : 'tenant',
      options      :  tenants,
      value        :  tenant,
      onChange     : (event, inputValue) => { setTenant( inputValue || '' ) },
      autoComplete : 'off',
      freeSolo     : true,
      renderInput  : (params) => ( <TextField {...params} label='Tenant' /> ),
      name         : 'add_tenant_input',
    },
    AUDIT_MODE = {
      id           : 'audit-mode',
      options      :  auditModes, 
      value        :  auditMode,
      autoComplete : 'off',
      freeSolo     : true,
      onChange     : (event, inputValue) => { setAuditMode( inputValue || '' ) },
      renderInput  : (params) => ( <TextField {...params} label='Audit Mode' /> ),
      name         : 'add_audit_mode_input',
    },
    AUDIT_TYPE_LABEL = {
      id           :'audit-type',
      children     :'Audit Type',
    },
    AUDIT_TYPE = {
      id           : 'audit-type',
      labelId      : 'audit-type',
      value        :  auditType,
      autoComplete : 'off',
      input        : <OutlinedInput label='Audit Type'/>,
      onChange     : (event) => { setAuditType(event.target.value); },
      children     : auditTypeOptions.map((option) => (<MenuItem key={option} value={option}>{option}</MenuItem>)),
      name         : 'audit_type_select',
    },
    FIELD_NAME = {
      id           : 'field-name',
      label        : 'Field Name',
      value        : fieldName,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      onChange     : (event) => { setFieldName(event.target.value); },
      name         : 'field_name_input',
    },
    FIELD_VALUE = {
      id           : 'field-value',
      label        : 'Field Value',
      autoComplete : 'off',
      fullWidth    : true,
      value        : fieldValue,
      type         : 'text',
      margin       : 'dense',
      onChange     : (event) => { setFieldValue(event.target.value); },
      name         : 'field_value_input'
    },
    AUDIT_RETURN_CODE_LABEL = {
      id           :'audit-return-code', 
      children     :'Audit Return Code',
    },
    AUDIT_RETURN_CODE = {
      id           : 'audit-return-code',
      labelId      : 'audit-return-code',
      value        :  auditReturnCode,
      autoComplete : 'off',
      input        : <OutlinedInput label='Audit Return Code'/>,
      onChange     : (event) => { setAuditReturnCode(event.target.value); },
      children     : auditReturnCodeOptions.map((option) => (<MenuItem key={option} value={option}>{option}</MenuItem>)),
      name         : 'audit_return_code_select',
      },
    AUDIT_FREQUENCY = {
      id           : 'audit-frequency',
      label        : 'Audit Frequency',
      value        :  auditFrequency,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      onChange     : (event) => { setAuditFrequency(event.target.value); },
      name         : 'audit_frequency_input',
    },
    AUDIT_COUNT = {
      id           : 'autid-count',
      label        : 'Audit Count',
      value        :  auditCount,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      onChange     : (event) => { setAuditCount(event.target.value); },
      name         : 'audit_count_input',
    },
    
    BUTTON_CANCEL = {
      color    : 'primary',
      onClick  : handleClose,
      children : [ 'Cancel' ],
      name     : 'cancel_add_audit_qc_row_btn',
    },
    
    BUTTON_ADD = {
      color    : 'primary',
      onClick  : handleSubmitAddAuditQC,
      children : [ 'Submit' ],
      name     : 'submit_audit_qc_row_btn',
    },
    BUTTON_ADD_AND_CLOSE = {
      color    : 'primary',
      onClick  : handleSubmitAddAutoQCAndClose,
      children : [ 'Add & Close' ],
      name     : 'add_and_close_audit_qc_row_btn',
    };
 
  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function addRow() {
    //-----------------------------------------------------------------
    try{
      let error_text = '';
      if ( !tenant  ) error_text    += ', Tenant must be filled';
      if ( !auditMode ) error_text  += ', Audit Mode  must be filled';
      if ( !auditType ) error_text  += ', Audit Type  must be filled';
      if ( !fieldName ) error_text  += ', Field Name  must be filled';
      if ( !fieldValue ) error_text += ', Field Value must be filled';      
     
      if (error_text) {
        setAlertText(error_text.substring(2));
        setShowAlert(true);
        return false;
      }
     
      let field_data = {
        tenant,
        auditMode,
        auditType,
        fieldName,
        fieldValue,
        auditReturnCode,
        auditFrequency,
        auditCount,
      };
     
      prokeyAuditQCCreate(field_data);

      return true;
    } catch (error) {
      console.log( error );
    }
  }
  
  //-----------------------------------------------------------------
  function resetData() {
    //-----------------------------------------------------------------
    setTenant('');
    setAuditMode('');
    setAuditType('');
    setFieldName('');
    setFieldValue('');
    setAuditReturnCode('');
    setAuditFrequency( 1 );
    setAuditCount( 0 );
  }; 
 
  //#endregion
  
  //#region [EVENTS]
  
  useEffect(() => {
    //-----------------------------------------------------------------
    function handleTenants( data ) {
      //-----------------------------------------------------------------
      const tenantList = data.map(tenant => tenant || 'default')
        setTenants( tenantList );
    };
     //-----------------------------------------------------------------
     function handleAuditModes( data ) {
      //-----------------------------------------------------------------
      setAuditModes( data );
    };
   
    onTenants( handleTenants );
    onAuditModes( handleAuditModes );

    requestTenants();
    requestAuditModes();
    
     return () => {
      removeListener( 'TENANT-REQUEST', handleTenants );
      removeListener( 'PROKEY-AUDIT-MODE-REQUEST', handleAuditModes );
    }
  }, []);

  //-----------------------------------------------------------------
  function handleSubmitAddAuditQC() {
    //-----------------------------------------------------------------
    if (addRow()) {
      resetData();
    }
  };

  //-----------------------------------------------------------------
  function handleSubmitAddAutoQCAndClose() {
    //-----------------------------------------------------------------
    if (addRow()) {
      handleClose();
      resetData();
    }
  };

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    props.setShowDialog(false);
    handleDismissAlert();
    resetData();
  };

  //-----------------------------------------------------------------
  function handleDismissAlert() {
    //-----------------------------------------------------------------
    setShowAlert(false);
    setAlertText('');
  };

  //-----------------------------------------------------------------
  function handleErrClose(event, reason) {
    //-----------------------------------------------------------------
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };
  //#endregion

  //#region [DISPLAY]
  
  //-----------------------------------------------------------------
  function displayError() {
    //-----------------------------------------------------------------
    return (
        <Snackbar open={showAlert} autoHideDuration={4000} onClose={handleErrClose} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
        <div>
          <Alert onClose={handleErrClose} severity='error'>
            {alertText}
          </Alert>
        </div>
      </Snackbar>
    );
  };

  //-----------------------------------------------------------------
  function displayAddAuditQCModal() {
    //-----------------------------------------------------------------
    return props.showDialog ? (
      <div { ...CONTAINER      } >
        <Dialog { ...DIALOG    } >
          <DialogTitle id='form-dialog-title' variant='primary' sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>Add Audit QC Row</DialogTitle>
          <DialogContent sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >
            <DialogContentText>Enter information</DialogContentText>
            <FormControl    { ...FORM    } >
              <Autocomplete { ...TENANT  } />
            </FormControl>
            <FormControl    { ...FORM          } >
              <Autocomplete { ...AUDIT_MODE    } />
            </FormControl>
            <FormControl  { ...FORM                } >
              <InputLabel { ...AUDIT_TYPE_LABEL    } />
              <Select     { ...AUDIT_TYPE          } />
            </FormControl>
            <TextField { ...FIELD_NAME           } />
            <TextField { ...FIELD_VALUE          } />
            <FormControl  { ...FORM                       } >
              <InputLabel { ...AUDIT_RETURN_CODE_LABEL    } />
              <Select { ...AUDIT_RETURN_CODE              } />
            </FormControl>
            <TextField { ...AUDIT_FREQUENCY      } />
            <TextField { ...AUDIT_COUNT          } />
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >
            <Button { ...BUTTON_CANCEL           } />
            <Button { ...BUTTON_ADD              } />
            <Button { ...BUTTON_ADD_AND_CLOSE    } />
          </DialogActions>
        </Dialog>
        {displayError()}
      </div>
    ) : null;
  }

  //#endregion

  return displayAddAuditQCModal();
}

export { AddAuditQCDialog };
